import request from '#/utils/request';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';

export async function fetchMtrTemplateDetail(id) {
  const { data: raw } = await request.get(`/mtr-template/${id}`);
  return parseVer4DetailResponse(raw);
}
